export * from './carousel-gallery.module';
export * from './carousel-gallery.component';
